import React, {useEffect, useRef, useState} from 'react';
import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import {agreementAuthCode} from '../../../components/utilities/models/gen-models';
import axios from '../../../components/utilities/axios';
import Alert from 'react-bootstrap/Alert';

const UserAgreement = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [showCodeField, setCodeField] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [pullingError, setPullingError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [agreeAuthCode, setAgreeAuthCode] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('success');
  const {register, handleSubmit,formState, formState: { errors }, reset} = useForm({
    resolver: yupResolver(agreementAuthCode),
  });
  const messagesEndRef = useRef(null)

  const handleChangeCheck = async () => {
    setIsChecked(!isChecked);
    setCodeField(!isChecked);
    // const titleRef = useRef();
    // scrollToBottom();
    // window.scrollTo({top: -0, behavior: 'smooth' })
    // titleRef.current.scrollIntoView({ behavior: 'smooth' })
    /*if(isChecked) {
      const agreeTerms = {
        agreeAuthCode, type: 'checked'
      }
      const {data} = await axios.post('/devices/agreement-authenticate', agreeTerms);
    }*/
  }


  const handleAuthUser = async (code) => {
    setProcessing(true);
    console.log('data', code);

    await spinnerHandler();
    setAgreeAuthCode(code)

    try {

      const {data} = await axios.post('/devices/agreement-authenticate', code);
      // console.log('show pull records', data);
      if (data.success) {
        // console.log(hideNin);
        // setShowTermPage(true);
        setShowAlert(true);
        setAlertType('success');
        setAlertMessage(data.message || 'User Authenticated Successfully')

      } else {
        /*setPullingError(true);
        setErrorMessage(data.message);*/
        setShowAlert(true);
        setProcessing(false);
        setAlertType('danger');
        setAlertMessage(data.message || 'Invalid verification code')
      }
      // handleShowAlert();
      // setShowAlert(true);
      setProcessing(false);
      // setShowForm(false);
      reset();

    } catch (e) {
      // console.log('e.message', e.message)
      setPullingError(true);
      setErrorMessage(e.message);
      setProcessing(false);
    }

  }

  const handleShowAlert = () => {
    return (
      <Alert variant={alertType} onClose={() => setShowAlert(false)} dismissible>
        {alertMessage && alertMessage}
      </Alert>
    );
  };

  /*const handleToggle = () => {
    setShowTermPage(!showTermPage)
  }*/

  useEffect(() => {
    // 👇️ scroll to bottom every time messages change
    messagesEndRef.current?.scrollIntoView({behavior: 'smooth'});
  }, [isChecked]);

  function spinnerHandler() {
    // return promise that resolves after 2 seconds
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 1000);
    });
  }

  const AuthAgreeForm = () => {
    return (
      <>
        <section className="pb-3 effect-section">
          <div className="particles-box" id="particles-box" />
          <div className="container">
            <div className="row">
              {/*<div className="col-12 col-lg-8 text-center">
                  <h1 className="text-white h1 mb-3"><u className="font-w-600">Case Management</u> </h1>
                </div>*/}
              <div className="col-12 col-lg-8 py-8 text-center wow fadeInUp" data-wow-duration="0.5s"
                   data-wow-delay="0.1s">
               {/* <h1 className=" h1 mb-3">cLBS Term Agreement, Authentication and, <u className="font-w-600 text-warning">
                  Verification</u> </h1>*/}
                <span className="lead text-success font-w-500 mb-2">cLBS Terms of use Agreement, Authentication and, <u className="font-w-600 text-warning">
                  Verification</u></span>
                <form className="mb-2 p-2 rounded-3 shadow bg-gray" onSubmit={handleSubmit(handleAuthUser)}>
                  <div className="row mt-0">
                    <div className="col-md-4">
                      <input type="text" name="phoneNumber" className="form-control form-control-lg rounded-3 border-1 border-warning shadow-none"
                             placeholder="Enter phone Number" {...register("phoneNumber")}/>
                      <div className="text-danger">{errors.phoneNumber?.message}</div>
                    </div>

                    <div className="col-md-4">
                      <input type="text" name="agreeAuthCode" className="form-control form-control-lg rounded-2 border-1  border-dark shadow-none"
                             placeholder="Enter verification  code" {...register("agreeAuthCode")}/>
                      <div className="text-danger">{errors.agreeAuthCode?.message}</div>
                    </div>
                    <div className="col-md-4">
                      <button className="btn btn-dark rounded-3 flex-shrink-0 shadow-none btn-md" type="submit"
                              disabled={processing} style={{marginTop: '6px'}}>{processing ? "processing..." : "Verify"}</button>
                    </div>
                  </div>
                 {/* <input type="text" name="agreeAuthCode" className="form-control form-control-lg rounded-0 border-0 shadow-none"
                         placeholder="Enter user  code" {...register("agreeAuthCode")}/>

                  <button className="btn btn-secondary rounded-3 flex-shrink-0 shadow-none" type="submit" onClick={() => handleSearchData()}>Search
                    </button>
                  <button className="btn btn-dark rounded-3 flex-shrink-0 shadow-none" type="submit"
                          disabled={processing}>{processing ? "processing..." : "Verify"}</button>

                  <div className="snackbars" id="form-output-global" />*/}

                </form>
                {/*<div className="text-danger">{errors.agreeAuthCode?.message}</div>*/}
                {
                  pullingError && <div className="text-danger small text-center">{errorMessage}</div>
                }
                {
                  <div>{showAlert && handleShowAlert()}</div>
                }
                {/*<span className="text-warning-50">This is an online real-time service</span>*/}
              </div>
              <div className="col-12 col-lg-10 wow fadeInUp" data-wow-duration="0.5s" data-wow-delay="0.1s">
                <img src="../../assets/img/home-banner/home-banner.jpg" title="" alt="" />
              </div>
            </div>
          </div>
        </section>
      </>
    )
  }

  const UserAgreementPage = () => {
    return (
      <div className="container">
        <div className="row" style={{marginTop:'2px'}}>
          <div className="col-md-12 text-center pt-3">
            <h3>cLBS USER AGREEMENT</h3>
          </div>
          <div className="col-md-12">
            This user agreement/authentication ("Agreement/Authentication") applies to you as a user of our clbs-related services through Ontrac Technology Limited and all other websites, mobile applications and services (collectively, the "Services") provided by cLBS.
            This Privacy Statement describes our practices in handling the information that you provide to us and that we collect about you as a user of our Services.
            This Privacy Statement applies to all users of our Services. It does not apply to our employees or to independent contractors, including drivers or providers of our transportation-related Services. We may store, maintain, process and/or transfer the information you provide to us and that we collect about you in a country or countries that may have less strict data protection laws than in the country where you reside. If so, we will take reasonable measures to protect your information in accordance with this Statement.
          </div>
          <div className="col-md-12">
            <h3>Disclaimer</h3>
            <p>By using any cLBS Products and Services, you agree that this
              End User User License Agreement (EULA) is a legally binding and valid contract and agree to be bound by it.
              You agree to abide by the intellectual property laws and all of the terms and conditions of this Agreement
            </p>
            <p className="font-w-600 text-warning">Click on accept agreement and register at the bottom of the page to get authenticated</p>
          </div>
          <div className="col-md-12 pt-3">
            <h3>Binding Agreement</h3>
            These Terms and Conditions (as they may be amended from time to time by cLBS), form a binding agreement (the "Agreement") between you and cLBS. Your access to or use of the cLBS Web Sites or Services indicates your acceptance of these Terms and Conditions. You are agreeing to use the Sites at your own risk.
          </div>
          <div className="col-md-12  pt-3">
            <h3>User Information and Privacy Policy</h3>
            <p>When you register on any of the cLBS application or in connection with the Services, you will be asked to
              create an account and provide cLBS with certain information, including but not limited to, a valid
              phone number ("User Information"). You acknowledge and agree that you have no ownership rights in your account.
            </p>
            <p>All User Information will be used in accordance with the terms of cLBS's Privacy Policy. Please note,
              as set forth in the Privacy Policy, that cLBS may collect certain User Information and may contact Users periodically in accordance with the terms of the Privacy Policy. In addition, cLBS reserves the right to comply, in its sole discretion, with legal requirements, requests from law enforcement agencies or requests from government entities, even to the extent that such compliance may require disclosure of certain User Information. In addition, third parties may retain cached copies of User Information.</p>
          </div>
          <div className="col-md-12  pt-3">
            <p>These terms embody all the terms of agreement between you and the company about use of the website. These terms entirely replace any other agreements about your use of the website, written or not.</p>
            <h3 id="contact">Contact</h3>
            <p>You may notify the company under these terms, and send questions to the company, at team@freecodecamp.org.</p>
            <p>The company may notify you under these terms using the e-mail address you provide for your account on the website, or by posting a message to the homepage of the website or your account page.</p>
            <h3 id="changes">Changes</h3>
            <p>cLBS may revise these Terms and Conditions at any time by updating this page. Changes will be binding on you
              on the date they are posted on the Sites (or as otherwise stated in the any notice of such changes).
              Any use of a Site will be considered acceptance by you of the then-current Terms and Conditions
              (including any exhibits thereto) contained on such Site. If at any time you find the Terms and Conditions
              unacceptable, you may not use the applicable Site any longer. Any new or different terms supplied by you
              are specifically rejected by cLBS unless cLBS agrees to them in a signed writing specifically including those new or different terms. cLBS may change the Sites at any time</p>
            <p>Once you get notice of an update to these terms, you must agree to the new terms in order to keep using the website.</p>
          </div>
          <div className="col-md-12">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" name="agreeTerms" onChange={handleChangeCheck}
              checked={isChecked}/>
              <label className="form-check-label" htmlFor="flexCheckChecked">
                clicks to accept agreement and register
              </label>
            </div>
            <div ref={messagesEndRef}>
              {
                showCodeField && <AuthAgreeForm />
              }
            </div>

          </div>
        </div>
      </div>
    );
  }
  return <UserAgreementPage />

};

export default UserAgreement;
